import { wagmiConfig } from '@shared/common/providers/Web3Provider/wagmi';

export const getChainNameById = (chainId?: number): string => {
  const foundChain = wagmiConfig.chains.find((chain) => chain.id === chainId);
  return foundChain ? foundChain.name.split(' ').at(0) ?? '' : 'Unknown Network';
};
